export enum PaymentType {
  CREDIT_CARD = 'credit_card',
  INVOICE = 'invoice',
  CORPORATE_INVOICE = 'corporate_invoice',
  WALLET = 'wallet'
}

export enum CardTypes {
  VISA = 'visa',
  MASTERCARD = 'mastercard'
}

export type PaymentMethod = {
  id: number;
  paymentType: PaymentType;
  cardType?: CardTypes;
  display: string;
  isReferenceRequired?: boolean;
  expiryDate?: string;
  isExpired?: boolean;
  isMada?: boolean;
  isEnabled?: boolean;
};

export type CreditCardDto = {
  id: number;
  last_4: string;
  type: string;
  expire_month: number;
  expire_year: number;
  is_expired: boolean;
};

export type CreditCardDtoTransformer = {
  id: number;
  last_4: string;
  type: string;
  expiry: string;
  is_mada?: boolean;
};

export type CorporateInvoiceDto = {
  id: number;
  name: string;
  is_enabled: boolean;
};

export type CreditCardsDtoTransformer = {
  cards?: CreditCardDtoTransformer[];
  corporate_invoices?: CorporateInvoiceDto[];
};

export type CreditCardsDto = {
  cards?: CreditCardDto[];
};

export type UserBalanceDto = {
  amount: number;
  outstandingBalance: number;
  cashableAmount: number;
  currency: string;
  fractionDigits: number;
};

export type UserBalanceModel = {
  amount: number;
  currency: string;
  fractionDigits: number;
};

export type CreateWalletInvoiceRequest = {
  amount: number;
  currency: string;
};

export type WalletInvoiceResponse = {
  id: string;
  status: string;
  amount: number;
  currency: string;
  errors: ErrorResponse[];
};

export type ErrorResponse = {
  type: string;
  code: string;
  message: string;
};

export type UserWalletConfigDto = {
  is_zero_wallet_balance: boolean;
  wallet_details: {
    amount: number;
    currency: string;
    fraction_digits: number;
  };
};

export type UserWalletConfigModel = {
  isZeroWalletBalance: boolean;
  userBalance: UserBalanceModel;
};
